import React, { useState, useContext, useEffect, useRef, useCallback } from "react";
import { RoleCtx, LangCtx, PayLoadCtx, FileCtx } from "../../../lib/context";
import "../Styles.css";
import "./uploadsStyles.css";
import Loader from "../../../lib/ui/loader/Loader";
import { validateYoutubeurl } from "../../../lib/validation";
import { Storage } from "aws-amplify";
import UploadForm from "./components/uploadForm";
import UploadFilesListItem from "./components/listItem";
import { getDoctorUploadFiles, deletewaitingroomupload } from "../../../actions/users";
import { getPatientMedicalFiles, createPatientMedicalFiles, deletePatientMedicalFile, scan, deleteS3 } from "../../../actions/appointment";
import { createDoctorFiles } from "../../../actions/schedule";
import NoData from "../../../lib/ui/nodata/NoData";
import UploadFileView from "./components/uploadFileView";
import { OffLineAPI } from "../../../offline-auth/api";
import { toast } from "react-toastify";
import { API } from "aws-amplify";
import axios from "axios";
// import fs from "fs";
import InputField from "../../../lib/ui/inputs/Input";
// import ClamScan from 'clamscan';

const FileUploads = (props) => {
    // const scanner = new ClamScan();
    const { l } = useContext(LangCtx);
    const { payload } = useContext(PayLoadCtx);
    const fileList = useRef(null);
    const { role } = useContext(RoleCtx);
    const [loading, setLoading] = useState(false);

    // const [data, setData] = useState(uploaddoc);
    // const [searchTerm, setSearchTerm] = useState('');
    const [uploaddoc, setUploaddoc] = useState([]);
    const [youtubeUrl, setYoutubeUrl] = useState("");
    // const [errorMsg, setErrorMsg] = useState({});
    const [selFile, setFileView] = useState(null);
    const [showInput, setShowInput] = useState(false);
    const [changeFileName, setChangeFileName] = useState("");
    const [holdUploadBody, setHoldUploadBody] = useState({});
    const [user, setUser] = useState("")

    useEffect(() => {
        if (role === "D"){
            setUser("doctor")
            loadDoctorFiles();
        } 
        else if (role === "P"){
            loadPatientFiles();
        } else if (role === "C") {
            setUser("clinic")
            loadDoctorFiles();
        }
    }, [role]);

    const loadDoctorFiles = () => {
        setLoading(true);
        getDoctorUploadFiles()
            .then((res) => {
                setLoading(false);
                if (res.status) {
                    setUploaddoc(res.data);
                    setYoutubeUrl("");
                }
            })
            .catch((err) => {
                if(API.isCancel(err)) {
                    console.log("API is canceled................");
                } else {
                    setLoading(false);
                }
                console.log("err ==== ", err);
            });
    };

    const loadPatientFiles = () => {
        setLoading(true);
        getPatientMedicalFiles()
            .then((res) => {
                setLoading(false);
                if (res.status) {
                    setUploaddoc(res.data);
                    setYoutubeUrl("");
                }
            })
            .catch((err) => {
                setLoading(false);
                console.log("err ==== ", err);
            });
    };

    const handleUploads = (data) => {
        if (role === "D" || role === "C") {
            try {
                setLoading(true);
                data["uploadname"] = changeFileName;
                let [baseName, extension] = changeFileName.split(".");
                let name = payload?.firstName ? payload.firstName : "";
                name += payload?.lastName ? "_" + payload.lastName : "";
                data["downloadname"] = `${baseName}_${name}.${extension}`;
                data["consultRole"] = user
                createDoctorFiles(data)
                    .then((res) => {
                        setLoading(false);
                        if (res.status) {
                            toast.success(l.file_uploaded_successfully, {
                                position: toast.POSITION.TOP_RIGHT,
                            });
                            loadDoctorFiles();
                        }
                    })
                    .catch((err) => {
                        let msg = err?.response?.data?.error ? err.response.data.error : "Please Try Again";
                        toast.error(msg, {
                            position: toast.POSITION.TOP_RIGHT,
                        });
                        setChangeFileName("")
                        setLoading(false);  
                    })
            } catch (e) {
                setLoading(false);
                console.log("Error", e);
            }
        } else if (role === "P") {
            try {
                setLoading(true);
                data["uploadname"] = changeFileName;
                let [baseName, extension] = changeFileName.split(".");
                let name = payload?.firstName ? payload.firstName : "";
                name += payload?.lastName ? "_" + payload.lastName : "";
                data["downloadname"] = `${baseName}_${name}.${extension}`;
                createPatientMedicalFiles(data)
                    .then((res) => {
                        setLoading(false);
                        if (res.status) {
                            toast.success(l.file_uploaded_successfully, {
                                position: toast.POSITION.TOP_RIGHT,
                            });
                            loadPatientFiles();
                        }
                    })
                    .catch((err) => {
                        let msg = err?.response?.data?.error ? err.response.data.error : "Please Try Again";
                        toast.error(msg, {
                            position: toast.POSITION.TOP_RIGHT,
                        });
                        setLoading(false);
                    });
            } catch (e) {
                setLoading(false);
                console.log("Error", e);
            }
        }
    };

    const handleYoutubeUrl = async (e) => {
        e.preventDefault();

        if (youtubeUrl !== "" && validateYoutubeurl(youtubeUrl)) {
            let id = "";
            let url = youtubeUrl.replace(/(>|<)/gi, "").split(/(vi\/|v=|\/v\/|youtu\.be\/|\/embed\/)/);
            if (url[2] !== undefined) {
                id = url[2].split(/[^0-9a-z_-]/i);
                id = id[0];
            } else {
                id = url;
            }
            let videoTitle = id;
            // get youtube video title
            try {
                const youtubeVideoRes = await axios.get(
                    `https://youtube.googleapis.com/youtube/v3/videos?part=snippet&id=${id}&key=${process.env.REACT_APP_youtubeApiKey}`
                );
                const videoObj = Object(youtubeVideoRes?.data?.items[0]);
                const { title } = Object(videoObj.snippet);
                if (title) videoTitle = title;
            } catch (error) {
                console.log("error", error);
                console.log("Failed to get video title");
            }
            let _uploaddoc = uploaddoc.filter((itm) => itm.uploadkey === id);
            if (_uploaddoc && _uploaddoc.length > 0) {
                toast.error(l.link_exists, {
                    position: toast.POSITION.TOP_RIGHT,
                });
            } else {
                const body = {
                    url: "https://www.youtube.com/embed/" + id,
                    // uploadkey: id + '.youtube',
                    uploadkey: id,
                    uploadtype: "youtubeUrl",
                    size: "",
                    //  date: file.lastModified,
                    uploadname: videoTitle,
                };

                handleUploads(body);
            }
        } else {
            toast.error(l.enter_valid_youtube, {
                position: toast.POSITION.TOP_RIGHT,
            });
            setLoading(false);
            setYoutubeUrl("");
        }
    };
    /**
     * @param {string} fileName - name of the file
     * @param {Object} file - file to upload
     * @param {string} role - doctor or patient
     */
    const uploadOnlineOrOffline = (fileName, file, role) => {
        return new Promise(async (resolve, reject) => {
            let body = {
                uploadtype: file.type,
                size: file.size,
                //  date: file.lastModified,
                uploadname: file.name,
            };
            if (process.env.REACT_APP_isOffline === "true") {
                //upload to server folder
                const formData = new FormData();
                formData.append("fileData", file);
                let offlineApiPath = "";
                let urlPath = `${process.env.REACT_APP_api_server}/api/uploads/`;
                try {
                    // check user role
                    switch (role) {
                        case "D":
                            offlineApiPath = "uploaddoctor";
                            urlPath = `${urlPath}doctorUploads`;
                            break;
                        case "P":
                            offlineApiPath = "patientmedicalhistoryupload";
                            urlPath += `${urlPath}patientMedicalHistory`;
                            break;
                    }
                    const offlineUploadRes = await OffLineAPI.upload("api", offlineApiPath, formData);
                    body = {
                        ...body,
                        url: `${urlPath}/${offlineUploadRes.path}`,
                        uploadkey: offlineUploadRes.path,
                    };
                } catch (error) {
                    console.log("eee", error);
                    return reject(error);
                }
            } else {
                //upload to s3 bucket
                try {
                    // Storage.configure({ bucket: process.env.REACT_APP_s3, region: process.env.REACT_APP_CognitoRegion });
                    // const s3UploadRes = await Storage.put(fileName.replace(/ /g, "_"), file, { contentType: file.type });
                    // console.log("s3UploadRes", s3UploadRes);
                    // body = {
                    //     ...body,
                    //     url: "https://insta-consult.s3-ap-southeast-1.amazonaws.com/public/" + s3UploadRes.key,
                    //     uploadkey: s3UploadRes.key,
                    // };

                    const formData = new FormData();
                    formData.append("file", file);

                    let params = {
                        bucket: process.env.REACT_APP_s3,
                        fileName: `public/${fileName.replace(/ /g, "_")}`,
                        region: process.env.REACT_APP_s3Region,
                    };

                    let s3UploadRes = await scan(formData, params);

                    if (s3UploadRes && s3UploadRes.status) {
                        s3UploadRes = s3UploadRes.data;
                        body = {
                            ...body,
                            url: `https://${process.env.REACT_APP_s3}.s3-${process.env.REACT_APP_s3Region}.amazonaws.com/` + s3UploadRes.Key,
                            uploadkey: s3UploadRes.Key,
                        };
                    } else {
                        console.log("s3UploadRes.........:)", s3UploadRes);
                        toast.error(s3UploadRes.error, {
                            position: toast.POSITION.TOP_RIGHT,
                        });
                        resolve({});
                        // reject(s3UploadRes.error)
                    }
                } catch (error) {
                    return reject(error);
                }
            }
            return resolve(body);
        });
    };

    // async function scanFile(filePath) {
    //     console.log("scanFile", filePath);
    //     const apiEndpoint = 'https://antivirusapi.example.com/scan';

    //     // Read the file data as binary
    //     const fileData = await fs.promises.readFile(filePath);

    //     // Make a POST request to the antivirus scanning API
    //     const response = await axios.post(apiEndpoint, fileData, {
    //         headers: {
    //             'Content-Type': 'application/octet-stream',
    //         },
    //     });
    //     console.log("response.data.scanResults", response.data.scanResults)

    //     // Process and return the scan results
    //     return response.data.scanResults;
    // }

    // const uploadscan = async (file) => {
    //     // Scan the file using ClamScan
    //     scanner.scan(file.path, (err, file, isInfected) => {
    //         if (err) {
    //             console.log('Error scanning file:', err);
    //             return false;
    //         } else if (isInfected) {
    //             console.log('File is infected:', file);
    //             // Handle infected file (e.g., quarantine or reject)
    //             return false;
    //         } else {
    //             console.log('File is clean:', file);
    //             // Proceed with file handling or storage
    //             return true
    //         }
    //     });
    // };

    // const scanFile = (fileContents) => {
    //     // const ClamScan = require('js-clamscan');
    //     // const scanner = new ClamScan();

    //     scanner.scan_buffer(fileContents, (err, object, malicious) => {
    //         if (err) {
    //             console.log('Error scanning file:', err);
    //         } else if (malicious) {
    //             console.log('File is infected:', object.path);
    //             // Handle infected file (e.g., show error message, reject upload)
    //         } else {
    //             console.log('File is clean:', object.path);
    //             // Proceed with file handling or storage
    //         }
    //     });
    // };

    // const readFileContents = (file) => {
    //     return new Promise((resolve, reject) => {
    //         const reader = new FileReader();
    //         reader.onload = (event) => resolve(event.target.result);
    //         reader.onerror = (error) => reject(error);
    //         reader.readAsArrayBuffer(file);
    //     });
    // };

    // const handleFileUpload = async (file) => {
    //     const apiKey = 'bb8b87e525c63f9e60caae3779737d0e75b35e58dc32364b7c95c375cba9df64';//'YOUR_API_KEY'; // Replace with your VirusTotal API key

    //     const formData = new FormData();
    //     formData.append('file', file);

    //     try {
    //         const response = await axios.post(
    //             `https://www.virustotal.com/vtapi/v2/file/scan?apikey=${apiKey}`,
    //             formData
    //         );

    //         console.log('Scan result:', response.data);
    //         return response.data

    //         // Handle the scan result as needed
    //     } catch (error) {

    //         console.log('Error scanning file:', error);
    //         return false;
    //     }
    // };

    const handleUploadFile = async (e) => {
        if (e.target.files.length > 0) {
            // const acceptedTypes = ["image/jpeg", "image/jpg", "image/png", "application/dicom", "application/pdf","video/mp4"," application/xls", "application/xlsx", "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", ".doc", ".docx", ".ppt", ".pptx", "application/vnd.ms-powerpoint", "application/vnd.openxmlformats-officedocument.presentationml.presentation", "application/vnd.openxmlformats-officedocument.wordprocessingml.document"];
            const notAcceptedType = [
                ".apk",
                ".ahk",
                ".jar",
                ".ipa",
                ".run",
                ".cmd",
                ".xbe",
                ".0xe",
                ".bms",
                ".workflow",
                ".exe",
                ".bin",
                ".8ck",
                ".bat",
                ".elf",
                ".sk",
                ".gadget",
                ".air",
                ".ac",
                ".xap",
                ".app",
                ".widget",
                ".x86",
                ".fba",
                ".u3p",
                ".mcr",
                ".pif",
                ".rbf",
                ".com",
                ".xlm",
                ".appimage",
                ".sh",
                ".tpk",
                ".out",
                ".gpe",
                ".73k",
                ".vlx",
                ".ex_",
                ".script",
                ".x86_64",
                ".rxe",
                ".scr",
                ".command",
                ".scb",
                ".tcp",
                ".paf.exe",
                ".scar",
                ".xex",
                ".hta",
                ".torrent",
                ".isu",
                ".ps1",
                ".action",
                ".ws",
                ".ebs2",
                ".coffee",
                ".acc",
                ".celx",
                ".cgi",
                ".rfu",
                ".fxp",
                ".ecf",
                ".vpm",
                ".phar",
                ".89k",
                ".plsc",
                ".xbap",
                ".azw2",
                ".rpj",
                ".scpt",
                ".fas",
                ".ex5",
                ".e_e",
                ".cof",
                ".tgz",
                ".dld",
                ".mlx",
                ".js",
                ".caction",
                ".a6p",
                ".wsh",
                ".vbs",
                ".vxp",
                ".ex4",
                ".mcr",
                ".ex_",
                ".jsf",
                ".server",
                ".a7r",
                ".ba_",
                ".pex",
                ".cheat",
                ".esh",
                ".shb",
                ".dek",
                ".fpi",
                ".iim",
                ".jsx",
                ".plx",
                ".acr",
                ".exe1",
                ".icd",
                ".pwc",
                ".nexe",
                ".wcm",
                ".ear",
                ".pyc",
                ".mel",
                ".zl9",
                ".mm",
                ".snap",
                ".paf",
                ".ms",
                ".ebm",
                ".mcr",
                ".exe",
                ".atmx",
                ".actc",
                ".mpk",
                ".hms",
                ".frs",
                ".gm9",
                ".shortcut",
                ".uvm",
                ".otm",
                ".rgs",
                ".pyo",
                ".widget",
                ".mrc",
                ".wiz",
                ".csh",
                ".applescript",
                ".spr",
                ".cyw",
                ".sct",
                ".ebs",
                ".epk",
                ".gs",
                ".prg",
                ".osx",
                ".mrp",
                ".fas",
                ".app",
                ".xqt",
                ".fky",
                ".prg",
                ".ygh",
                ".kx",
                ".actm",
                ".mxe",
                ".vbscript",
                ".app",
                ".rox",
                ".cel",
                ".vexe",
                ".tms",
                ".kix",
                ".seed",
                ".n",
                ".tiapp",
                ".ezs",
                ".thm",
                ".beam",
                ".udf",
                ".vbe",
                ".jse",
                ".prg",
                ".s2a",
                ".wpk",
                ".rfs",
                ".dmc",
                ".hpf",
                ".exz",
                ".ipk",
                ".prc",
                ".mhm",
                ".scptd",
                ".msl",
                ".ls",
                ".sca",
                ".xys",
                ".wpm",
                ".ms",
                ".ita",
                ".wsf",
                ".qit",
                ".lo",
                ".es",
                ".arscript",
                ".rbx",
                ".ds",
                ".eham",
                ".mem",
                ".ebacmd",
                ".mam",
                ".ncl",
                ".dxl",
                ".ksh",
                ".upx",
                ".btm",
                ".ham",
                ".mio",
                ".ipf",
                ".vdo",
                ".pvd",
                ".gpu",
                ".exopc",
                ".mac",
                // ".zip",
                ".sbs",
                ".asb",
                ".cfs",
                ".pxo",
                ".sts",
                ".sapk",
                ".mamc",
                ".qpx",
                ".uw8",
                ".afmacro",
                ".afmacros",
                ".73p",
                ".89z",
                ".ore",
                ".ezt",
                ".smm",
                ".html",
            ];
            let file = e.target.files[0];
            
            const fileAlreadySelected = Array.isArray(uploaddoc) && uploaddoc?.some((f) => f?.uploadname?.toLowerCase() === file?.name?.toLowerCase());
            
            let extension = file.name.split(".").pop();
            
            if (fileAlreadySelected) {
                // setLoader(false);
                toast.dismiss();
                toast.error("File already existed");
                // toast.error("File already exists")
                return;
            }

            if (file && notAcceptedType.includes(`.${extension}`)) {
                toast.error("Uploaded file format not supported", {
                    position: toast.POSITION.TOP_RIGHT,
                });
            } else if (file && file.size / (1024 * 1024) < 15) {
                setLoading(true);
                try {
                    let filename = new Date().valueOf() + file.name;
                    if (role === "D") filename = "doctorUploads/" + filename;
                    else if (role === "C") filename = "clinicUploads/" + filename;
                    else if (role === "P") filename = "patientMedicalHistory/" + filename;

                    // handle offline or online upload
                    try {
                        // const formData = new FormData();
                        // formData.append("file", file);
                        // const url = 'https://www.hybrid-analysis.com/api/v2/submit/file';

                        // axios.post(url, formData, {
                        //     headers: {
                        //         'api-key': 'zuenkm1a7eb24286dqu1j1016bc9c4e4i57n4ygq5ec8820b35i2g8hv4e4c4342',
                        //         'Content-Type': 'application/octet-stream',
                        //         'cors':true
                        //     },
                        // })
                        //     .then(response => {
                        //         console.log('Analysis ID:', response.data.job_id);
                        //         // Process the analysis ID or handle the response as needed
                        //     })
                        //     .catch(error => {
                        //         console.error('Error analyzing file:', error);
                        //     });

                        // const scanResults = await scanFile(formData);
                        // console.log('Scan results:', scanResults);
                        // if (scanResults.detected) {
                        //     toast.error("File detected as malicious", {
                        //         position: toast.POSITION.TOP_RIGHT,
                        //     });
                        //     // res.status(403).json({ message: 'File detected as malicious' });
                        //     return
                        // }

                        // const fileContents = await readFileContents(file);

                        // let res = await scanFile(fileContents)
                        // console.log('.......:', res);

                        // let res = await handleFileUpload(file);

                        // console.log('res...........:', res);

                        // if (!res) {
                        //     toast.error("File detected as malicious", {
                        //         position: toast.POSITION.TOP_RIGHT,
                        //     });
                        //     return
                        // }

                        const fileUploadResBody = await uploadOnlineOrOffline(filename, file, role);
                        if (Object.keys(fileUploadResBody).length <= 0) {
                            setLoading(false);
                            setShowInput(false);
                            return;
                        }
                        setShowInput(true);
                        setLoading(false);
                        setChangeFileName(fileUploadResBody?.uploadname);
                        setHoldUploadBody(fileUploadResBody);
                        // handleUploads(fileUploadResBody);
                    } catch (err) {
                        setLoading(false);
                        toast.error(err.errorMessage, {
                            position: toast.POSITION.TOP_RIGHT,
                        });
                    }
                    // code for aws s3 bucket
                    // Storage.configure({ bucket: config.s3.BUCKET });
                    // Storage.put(filename, file, { contentType: file.type, customPrefix: { public: "" } }).then(
                    //     (result) => {
                    //         // console.log(result);
                    //         const body = {
                    //             url: "https://insta-consult.s3-ap-southeast-1.amazonaws.com" + "/" + result.key,
                    //             uploadkey: result.key,
                    //             uploadtype: file.type,
                    //             size: file.size,
                    //             //  date: file.lastModified,
                    //             uploadname: file.name,
                    //         };
                    //     }
                    // );

                    // code for offline file save
                    // const formData = new FormData();
                    // formData.append('fileData', file);
                    // if (role === 'D') {
                    //     OffLineAPI.upload("api", "/uploaddoctor", formData)
                    //         .then(res => {
                    //             setLoading(false);
                    //             const body = {
                    //                 url: config.api_server + '/api/uploads/doctorUploads/' + res.path,
                    //                 uploadkey: res.path,
                    //                 //  name: file.name,
                    //                 uploadtype: file.type,
                    //                 size: file.size
                    //             }
                    //             handleUploads(body);
                    //         }).catch(err => {
                    //             console.log("error ====", err);
                    //             setLoading(false);
                    //         });
                    // }
                    // else if (role === 'P') {
                    //     OffLineAPI.upload("api", "/patientmedicalhistoryupload", formData)
                    //         .then(res => {
                    //             setLoading(false);
                    //             const body = {
                    //                 url: config.api_server + '/api/uploads/patientMedicalHistory/' + res.path,
                    //                 uploadkey: res.path,
                    //                 //  name: file.name,
                    //                 uploadtype: file.type,
                    //                 size: file.size
                    //             }
                    //             handleUploads(body);
                    //         }).catch(err => {
                    //             console.log("error ====", err);
                    //             setLoading(false);
                    //         });
                    // }
                } catch (e) {
                    setLoading(false);
                    console.log("Error", e);
                }
            } else {
                toast.error("File size should be below 15MB", {
                    position: toast.POSITION.TOP_RIGHT,
                });
            }
        }
    };

    // const handleSerach = (e) => {
    //     setSearchTerm(e.target.value)
    //     let val = e.target.value.trim();
    //     if (val.length > 1 || val.length === 0) {
    //         let filter = val.toUpperCase();
    //         let li = fileList.current.getElementsByClassName('listAutoUL');
    //         //  let li = parent.getElementsByClassName('listAutoContent');
    //         for (let i = 0; i < li.length; i++) {
    //             let a = li[i].getElementsByClassName("listAutoContent")[0].getElementsByClassName("listTxtL")[0];
    //             if (a) {
    //                 let txtValue = a.textContent || a.innerText;
    //                 if (txtValue.toUpperCase().indexOf(filter) > -1) {
    //                     li[i].style.display = "";
    //                     // searchfound = true;
    //                 } else {
    //                     li[i].style.display = "none";
    //                 }

    //             }
    //         }
    //     }
    // }

    const deleteDocument = useCallback(
        async (data) => {
            if (data.uploadkey) {
                await deleteOnlineOrOfflineFile(data.url, data.uploadkey);
            } else {
                let _uploaddoc = uploaddoc.filter((itm) => itm.url !== data.url);
                // setUploaddoc(_uploaddoc);
                setUploaddoc([..._uploaddoc]);
            }
        },
        [uploaddoc]
    );

    /**
     * @param {string} url - url of the file
     * @param {string} key
     */
    const deleteOnlineOrOfflineFile = async ( url, uploadkey ) => {
        setLoading(true);
        const body = { 
            url: url, 
            uploadkey: uploadkey, 
            consultRole : user 
        };
        try {
            if (process.env.REACT_APP_isOffline === "true") {
                switch (role) {
                    case "D":
                        await OffLineAPI.uploadDelete("api", "/deletewaitingroomfile", { body: url });
                        break;
                    case "P":
                        await OffLineAPI.uploadDelete("api", "/deletefile", { body });
                        break;
                }
            } else {
                // Storage.configure({ bucket: process.env.REACT_APP_s3, region: process.env.REACT_APP_profileRegion });
                // const s3DelRes = await Storage.remove(uploadkey);
                // console.log("s3DelRes", s3DelRes);
                // let params = {
                //     bucket: process.env.REACT_APP_s3,
                //     fileName: uploadkey,
                //     region: process.env.REACT_APP_s3Region,
                // };
                await Storage.remove(uploadkey);
                // let s3DeleteRes = await deleteS3(params);
            }
            switch (role) {
                case "D":
                    await deletewaitingroomupload(body);
                    break;
                case "P":
                    await deletePatientMedicalFile(body);
                    break;
                case "C":
                    await deletewaitingroomupload(body);
                    break;
            }
            setLoading(false);
            toast.dismiss();
            toast.success("File removed successfully", {
                position: toast.POSITION.TOP_RIGHT,
            });
            let _uploaddoc = uploaddoc.filter((itm) => itm.uploadkey !== uploadkey);
            setUploaddoc(_uploaddoc);
            _uploaddoc = uploaddoc.filter((itm) => itm.url !== url);
            setUploaddoc([..._uploaddoc]);
        } catch (err) {
            setLoading(false);
            console.log("error while delete file =====", err);
        }
    };

    /**
     * @deprecated replaced by deleteOnlineOrOfflineFile func
     */
    // const deleteFile = (data) => {
    //     // Storage.configure({ bucket: config.s3.BUCKET })
    //     let body = {
    //         uploadkey: data.uploadkey,
    //     };
    //     // console.log('body============', body)
    //     setLoading(true);
    //     if (role === "D") {
    //         deletewaitingroomupload(body)
    //             .then((res) => {
    //                 if (res.status) {
    //                     Storage.remove(data.uploadkey)
    //                         .then((response) => {
    //                             setLoading(false);
    //                             let _uploaddoc = uploaddoc.filter((itm) => itm.uploadkey !== data.uploadkey);
    //                             setUploaddoc(_uploaddoc);
    //                         })
    //                         .catch((err) => {
    //                             setLoading(false);
    //                             console.error("err===== in delete===", err);
    //                         });
    //                     // let url = {
    //                     //     key: data.uploadkey
    //                     // }
    //                     // OffLineAPI.uploadDelete("api", "/deletewaitingroomfile", { body: url })
    //                     //     .then(res => {
    //                     //         setLoading(false);
    //                     //         let _uploaddoc = uploaddoc.filter(itm => itm.url !== data.url);
    //                     //         setUploaddoc(_uploaddoc);
    //                     //     }).catch(err => {
    //                     //         console.log("error ====", err);
    //                     //         setLoading(false);
    //                     //     });
    //                 }
    //             })
    //             .catch((err) => {
    //                 setLoading(false);
    //                 console.error("err===== in delete===", err);
    //             });
    //     } else if (role === "P") {
    //         deletePatientMedicalFile(body)
    //             .then((res) => {
    //                 if (res.status) {
    //                     Storage.remove(data.uploadkey)
    //                         .then((response) => {
    //                             setLoading(false);
    //                             let _uploaddoc = uploaddoc.filter((itm) => itm.uploadkey !== data.uploadkey);
    //                             setUploaddoc(_uploaddoc);
    //                         })
    //                         .catch((err) => {
    //                             setLoading(false);
    //                             console.error("err===== in delete===", err);
    //                         });
    //                     // let url = {
    //                     //     url: data.url
    //                     // }
    //                     // OffLineAPI.uploadDelete("api", "/deletefile", url)
    //                     //     .then(res => {
    //                     //         setLoading(false);
    //                     //         let _uploaddoc = uploaddoc.filter(itm => itm.url !== data.url);
    //                     //         setUploaddoc(_uploaddoc);

    //                     //     }).catch(err => {
    //                     //         console.log("error ====", err);
    //                     //         setLoading(false);
    //                     //     });
    //                 }
    //             })
    //             .catch((err) => {
    //                 setLoading(false);
    //                 console.error("err===== in delete===", err);
    //             });
    //     }
    // };

    // const handleS3Delete = async (uploadkey) => {
    //     // Storage.configure({ bucket: process.env.REACT_APP_s3, region: process.env.REACT_APP_profileRegion });
    //     // const s3DelRes = await Storage.remove(uploadkey);
    //     // console.log("s3delData------", s3DelRes);
    //     let params = {
    //         bucket: process.env.REACT_APP_s3,
    //         fileName: uploadkey,
    //         region: process.env.REACT_APP_s3Region,
    //     };
                
    //     let s3DeleteRes = await deleteS3(params);
                
    //     toast.dismiss();

    //     toast.success("File removed successfully", {
    //         position: toast.POSITION.TOP_RIGHT,
    //     });

    //     setShowInput(false);
    // };

    const handleSaveUploads = () => {
        setShowInput(false);

        if (changeFileName !== holdUploadBody?.uploadname) {
            toast.success("File name changed successfully", {
                position: toast.POSITION.TOP_RIGHT,
            });
            let [baseName, extension] = changeFileName.split(".");
            let name = payload?.firstName ? payload.firstName : "";
            name += payload?.lastName ? "_" + payload.lastName : "";
            holdUploadBody["downloadname"] = `${baseName}_${name}.${extension}`;
        }
        handleUploads(holdUploadBody);
    };

    // const acceptedTypes = ["jpeg", "jpg", "png", "doc", "docx", "pdf", "xls", "xlsx", "ppt", "pptx", "mp4"];
    const acceptedTypes = ["jpeg", "jpg", "png", "mp4"];


    return (
        <div className="baseContainer">
            <div className="uploadHdngTopCol">
                <div className="uploadsHdngTopBox">
                    {/*** For Doctor ****/}
                    {role && role === "P" ? <h2 className="topHdngTxt">{l.my_uploads}</h2> : <h2 className="topHdngTxt">{l.upload_ads}</h2>}
                </div>
                <div className="colBlock whiteBg borderBtm">
                    <UploadForm
                        youtubeUrl={youtubeUrl}
                        role={role}
                        handleUploadFile={handleUploadFile}
                        handleYoutubeUrl={handleYoutubeUrl}
                        handleChange={(e) => setYoutubeUrl(e.target.value)}
                        // accept="image/*, image/png,video/mp4, application/pdf, application/xls, application/xlsx, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, .doc,.docx,.ppt,.pptx, .mov,application/vnd.ms-powerpoint,application/vnd.openxmlformats-officedocument.presentationml.presentation, application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                    />
                </div>
            </div>
            <div className="filesListContainer">
                <div className="filesListHdr">
                    <div className="uploadFormHdng">
                        <p className="fileListHdng">{l.file_uploads}</p>
                    </div>
                    {/* <div className="fileSearchBlock">
                        <div className="searchBox searchFull">
                            <form method="post" className="searchForm" onSubmit={(e)=>e.preventDefault()}>
                                <input className="textbox" title="Search" value={searchTerm} placeholder={l.search} type="text" onChange={(e) => { handleSerach(e) }} />
                            </form>
                        </div>
                    </div> */}
                    <FileCtx.Provider value={{ selFile, setFileView }}>
                        <div className="fileUploadListBlock" ref={fileList}>
                            {loading && <Loader />}
                            {showInput && (
                                <div className="flexRow listAutoUL">
                                    <div className="listAutoAvtr flexAutoRow Md listAvatarFile">
                                        <img
                                            src={
                                                holdUploadBody?.uploadtype === "youtubeUrl"
                                                    ? `https://img.youtube.com/vi/${holdUploadBody?.uploadkey}/0.jpg`
                                                    : acceptedTypes?.includes(holdUploadBody?.uploadkey?.split(".")?.pop())
                                                    ? `/images/file-icons/${
                                                          holdUploadBody.uploadkey ? holdUploadBody.uploadkey.split(".").pop() : "blank"
                                                      }-file.png`
                                                    : "/images/file-icons/blank-file.png"
                                            }
                                            alt="avatar"
                                        />
                                    </div>
                                    <div className="flexMinWidthRow">
                                        <InputField
                                            placeholder="Change File Name"
                                            type="text"
                                            // maxLength="50"
                                            name="youtubeUrl"
                                            value={changeFileName}
                                            onChange={(e) => setChangeFileName(e.target.value)}
                                        />
                                    </div>
                                    <div className="flexAutoRow">
                                        <div className="listAutoAction" onClick={handleSaveUploads}>
                                            <div className="iconBtnBlock primary Sm ripple">Save</div>
                                        </div>
                                        {/* <div className="listAutoAction" onClick={() => handleS3Delete(holdUploadBody?.uploadkey)}>
                                            <div className="iconBtnBlock primary Sm ripple">
                                                <img src="/images/icons/delete-outline.png" alt="icon" className="invertPrimary" />
                                            </div>
                                        </div> */}
                                    </div>
                                </div>
                            )}
                            {uploaddoc?.length > 0
                                ? uploaddoc.map((item, i) => (
                                      <UploadFilesListItem
                                          file={item}
                                          key={`${item.key}_${i}`}
                                          deleteDocument={deleteDocument}
                                          access={true}
                                      />
                                  ))
                                : !showInput &&
                                  !loading && (
                                      <NoData Heading={l.no_files} src="/images/icons/uploaded_files.png" label={l.no_file_uploads} />
                                  )}
                        </div>
                    </FileCtx.Provider>
                    {selFile !== null && <UploadFileView open={selFile !== null} handleClose={() => setFileView(null)} data={selFile} />}
                </div>
            </div>
        </div>
    );
};

export default FileUploads;
